import Image, { ImageProps } from 'next/legacy/image';
import { USER_PHOTO_PLACEHOLDER_LINK } from 'consts';

export type UserPhotoProps = ImageProps & {
  src: string | null | undefined;
};

export const UserPhoto = ({ src, ...props }: UserPhotoProps) => (
  <Image src={src ? src : USER_PHOTO_PLACEHOLDER_LINK} layout="fill" objectFit="cover" alt="Photo" {...props} />
);
